module.exports = __webpack_public_path__ + "static/media/merch_fixed.f99e78bd.svg";